<div class="center">
  <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
</div>
<div>

  <form #newPasswordForm="ngForm" (ngSubmit)="submitPassword()">
    
    <div class="row">
      <div class="ps-2 col-12">
        To change your account password, please enter the requested information below.
      </div>
    </div>

    <div class="row">
      <div class="ps-2 col-4">
        <div class="mb-3 justify-content-center ps-0 pe-5 pt-3">
          <span>User ID: </span> <span class="ms-2"><b>{{userProfile.userName}}</b></span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="ps-2 col-3">
        <div class="mb-3 justify-content-center ps-0 me-3 pt-3">
          <label for="oldPassword" class="required">Current Password</label>
          <input appPassword [(ngModel)]="model.oldPassword" name="oldPassword" class="form-control" id="oldPassword"
            autocomplete="current-password" #oldPassword="ngModel" placeholder="Current Password" 
            required
            [ngClass]="{'error-input': oldPassword.errors && newPasswordForm.submitted}" />
          <ng-container *ngIf="(oldPassword.errors && newPasswordForm.submitted)">
            <span *ngIf="oldPassword.errors" class="failed">Password is incorrect.</span>
          </ng-container>
        </div>
        <div class="mb-3 justify-content-center ps-0 me-3 pt-3">
          <label for="newPassword" class="required">New Password <sup><i class="fa fa-circle-info large" style="color: #004381; margin-left: .1em;" 
            pTooltip="The new password must not contain spaces at the beginning or end, be at least 8 characters, and must contain at least one of the following: ! @ # $ ^ _ . or ," tooltipPosition="top"
          tooltipStyleClass="toolCardData" appendTo="body"></i></sup></label>
          <input appPassword [(ngModel)]="model.newPassword" id="newPassword" name="newPassword" class="form-control" appNoLeadingTrailingSpaces
            autocomplete="new-password" #password="ngModel" placeholder="New Password" minlength="8" [maxlength]="MaxLen.Password" pattern=".*[!@#$^_.,].*"
             (input)="confirmpassword.control.updateValueAndValidity()" (focus)="focusNewPassword()" (blur)="blurNewPassword()" required
            [ngClass]="{'error-input': password.errors && newPasswordForm.submitted}" />
          <ng-container *ngIf="password.invalid || (password.errors && newPasswordForm.submitted)">
            <span *ngIf="(password.dirty && password.invalid && newPasswordFocused) || (password.errors && newPasswordForm.submitted) 
            " class="failed">Password does not meet the minimum requirements.</span>
          </ng-container>
        </div>
        <div class="mb-3 justify-content-center ps-0 me-3 pt-3">
          <label for="confirmPassword" class="required">Confirm Password</label>
          <input appPassword [(ngModel)]="dummy.password" class="form-control" class="form-control" [maxlength]="MaxLen.Password"
            autocomplete="new-password" id="confirmPassword" [appExactMatch]="password" name="confirmpassword" #confirmpassword="ngModel"
            placeholder="Confirm Password" (focus)="focusConfirmPassword()" (blur)="blurConfirmPassword()" required
            [ngClass]="{'error-input': dummy.password === '' && newPasswordForm.submitted}" />
           <ng-container *ngIf="(password.valid && confirmPasswordFocused && dummy.password !== '' && !confirmpassword.valid) || (dummy.password === ''  && newPasswordForm.submitted) ">
            <span class="failed">Confirm password must match New Password.</span>
          </ng-container>
        </div>
      </div>
    </div>
    <div>
      <div class="mb-3 ps-0 pe-5 pt-3">
        <button type="submit" class="btn btn-primary px-4 mb-2">Change Password</button>
      </div>
    </div>

  </form>

</div>